function pluralize(time, label) {
  if (time === 1) {
    return time + label
  }
  return time + label + 's'
}
export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time)
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute')
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour')
  } else {
    return pluralize(~~(between / 86400), ' day')
  }
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }

  if ((time + '').length === 10) {
    time = +time * 1000
  }

  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    date = new Date(parseInt(time))
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
}

/* 数字 格式化*/
export function nFormatter(num, digits) {
  const si = [
        { value: 1E18, symbol: 'E' },
        { value: 1E15, symbol: 'P' },
        { value: 1E12, symbol: 'T' },
        { value: 1E9, symbol: 'G' },
        { value: 1E6, symbol: 'M' },
        { value: 1E3, symbol: 'k' }
  ]
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value + 0.1).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
    }
  }
  return num.toString()
}

export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

export function toThousandslsFilter(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}


/**
 * 自定义过滤器
 */
//时间过滤器 fdetal true 返回时分秒
export function toTimeFormat(time, fdetal){
  if(!time) return '';
  if(typeof time=="object"){
    let date = new Date(time);
    const f = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds()
    }
    let time_str = f.y + "-" + f.m.toString().padStart(2, "0") + "-" + f.d.toString().padStart(2, "0");
    if(fdetal){
      return time_str+=" " + f.h.toString().padStart(2, "0") + ":" + f.i.toString().padStart(2, "0") + ":" + f.s.toString().padStart(2, "0");
    }else{
      return time_str;
    }
  }else{
    if(fdetal) {
      //let time_str = time.replace(" ", " ");
      return time;//.split(".")[0];
    }else {
      return time.split(" ")[0];
    }
  }
}

export function AddDate(date,addDays){ //date传入你需要的日期，格式"xxxx-xx-xx"。addDays传要加减的日期数，往前传正数，往后传负数
    var Dates = new Date(date);
    Dates.setDate(Dates.getDate() + addDays);
    var mon = Dates.getMonth() + 1,
        day = Dates.getDate();
    if(mon < 10){
        mon = "0" + mon;//月份小于10，在前面补充0
    }
    if(day < 10){
        day = "0" + day;//日小于10，在前面补充0
    }
    return Dates.getFullYear() + "-" + mon + "-" +day;
}

/**布尔过滤器 */
export function toBool(value){
  return value ? '是' : '否';
}

/**卡券状态过滤器 */
export function cardStatus(value){
  let str = "";
  switch(value){
    case 10: str = "生成"; break;
    case 20: str = "已关联"; break;
    case 30: str = "已定义"; break;
    case 35: str = "已销售未激活"; break;
    case 40: str = "已激活"; break;
    case 50: str = "已预约"; break;
    case 60: str = "已提货"; break;
    case 70: str = "作废"; break;
  }
  return str;
}

/**产品类型过滤器 */
export function productType(value){
  let str = "";
  switch(value){
    case 10: str = "组合产品"; break;
    case 20: str = "物料"; break;
    case 30: str = "辅料"; break;
    case 40: str = "卡券"; break;
  }
  return str;
}

export function orderStatus(value){
  let str = "";
  switch(value){
    case 10: str = "审核中"; break;
    case 20: str = "已审核"; break;
    case 30: str = "处理中"; break;
    case 40: str = "完成"; break;
    case 50: str = "作废"; break;
    case 60: str = "退货中"; break;
    case 70: str = "退货成功"; break;
  }
  return str;
}

export function payStatus(value){
  let str = "";
  switch(value){
    case 10: str = "未付款"; break;
    case 20: str = "授权提货"; break;
    case 25: str = "未付全款"; break;
    case 28: str = "信用额度付款"; break;
    case 30: str = "已付款"; break;
    case 40: str = "退款"; break;
    case 50: str = "作废"; break;
  }
  return str;
}

export function payType(value){
  let str = "";
  switch(value){
    case 10: str = "现金"; break;
    case 20: str = "微信"; break;
    case 30: str = "支付宝"; break;
    case 40: str = "银行转账"; break;
    case 50: str = "支票"; break;
    case 60: str = "其他"; break;
    case 70: str = "POS"; break;
    case 80: str = "预付款"; break;
  }
  return str;
}
export function payType2(value){
  let str = "";
  switch(value){
    case 'alipay': str = "支付宝"; break;
    case 'wepay': str = "微信"; break;
    case 'transfers': str = "对公转账"; break;
  }
  return str;
}

// 预约单状态
export function takeOrderStatus(value){
  let str = "";
  switch(value){
    case 5: str = "待确认"; break;
    case 10: str = "登记"; break;
    case 15: str = "拆合单"; break;
    case 18: str = "已指派"; break;
    case 20:  str = "配送中"; break;
    case 30: str = "已发货"; break;
    case 40: str = "已退货"; break;
    case 50: str = "作废"; break;
  }
  return str;
}

// 预约单类型 标记：正常、拆分、合并
export function takeOrderType(value){
  let str = "";
  switch(value){
    case 10: str = "正常"; break;
    case 20: str = "拆后单"; break; // 从原单拆分后得到的单子
    case 25: str = "已拆分"; break; //拆分的原单
    case 30: str = "合后单"; break; // 多单合并后的单子
    case 35: str = "已合并"; break; // 合并的原单
  }
  return str;
}

//采购状态
export function stockStatus(value){
  let str = "";
  switch(value){
    case 5: str = "PDA草稿"; break;
    case 10: str = "审核中"; break;
    case 20: str = "已审核"; break;
    case 30: str = "部分完成"; break;
    case 35: str = "待补信息"; break;
    case 40: str = "全部完成"; break;
    case 50: str = "无效"; break;
  }
  return str;
}

//采购付款状态
export function stockPayStatus(value){
  let str = "";
  switch(value){
    case 10: str = "未付款"; break;
    case 20: str = "已付款"; break;
    case 30: str = "退款"; break;
    case 40: str = "作废"; break;
  }
  return str;
}

//采购明细状态
export function stockApplyItemStatus(value){
  let str = "";
  switch(value){
    case 10: str = "未入库"; break;
    case 20: str = "已入库"; break;
  }
  return str;
}

//调拨单状态
export function moveStatus(value){
  let str = "";
  switch(value){
    case 10: str = "审核中"; break;
    case 20: str = "已审核"; break;
    case 30: str = "无效"; break;
  }
  return str;
}

//公司客户付费类型
export function edition(value){
  let str = "";
  switch(value){
    case 10: str = "免费版"; break;
    case 15: str = "供应商版"; break;
    case 20: str = "基础版"; break;
    case 30: str = "高级版"; break;
    case 40: str = "专业版"; break;
  }
  return str;
}


/**开票产品类型过滤器 */
export function IProductTypeFilter(value){
  let str = "";
  switch(value){
    case 10: str = "组合"; break;
    case 20: str = "单品"; break;
  }
  return str;
}
